import React from 'react'
import { useTranslation } from 'react-i18next'
import { PHONE_VERIFICATION_STATUS } from 'lib/constants'
import { logException } from 'lib/errors'

import StatusTag from 'components/UI/StatusTag/StatusTag'

const statusColor = (status) => {
    switch (status) {
    case PHONE_VERIFICATION_STATUS.CONFIRMED:
        return 'green'
    case PHONE_VERIFICATION_STATUS.NOTCONFIRMED:
        return 'orange-light'
    default:
        logException(`Invalid status on statusColor: ${status}`)
    }
}

const PhoneStatusTag = ({ isMobileVerified }) => {
    const phoneVerifyStatus = isMobileVerified === true ? PHONE_VERIFICATION_STATUS.CONFIRMED : PHONE_VERIFICATION_STATUS.NOTCONFIRMED

    const { t } = useTranslation('editProfile')

    return (
        <StatusTag
            text={t(`editProfile:details.primary.fields.mobile.status.${phoneVerifyStatus.toLowerCase()}.label`)}
            statusColor={statusColor(phoneVerifyStatus)}
        />
    )
}

export default PhoneStatusTag
